import { defineStore } from 'pinia'
import { EaseChatClient } from '@/IM/initwebsdk'
import tool from '@/utils/tool'
import imuserApi from '@/api/onlineChat/imuserApi'
import { useImMessageStore  } from '@/store'

/**
 * 环信IM信息
 */
export const useImInfoStore = defineStore({
    id: 'imInfo',
    state: () => ({
        // 个人/企业IM信息
        imInfo: tool.session.get('IM_INFO') ||{},
    }),
    actions: {
        /**
         * 1.获取个人/企业环信IM信息
         * 2.登录环信
         * 3.获取会话列表
         */
        async getImInfo() {
            if (!tool.session.get('USER_INFO')) return
            const res =  tool.data.get('currentUserType') === 1 ? await imuserApi.imUserDetailOnLogin() : await imuserApi.imCompanyDetail()
            this.imInfo = res || {}
            tool.session.set('IM_INFO', this.imInfo)
            if (this.imInfo.accessToken) {
                EaseChatClient.open({ user: this.imInfo.userResource.username, accessToken: this.imInfo.accessToken })
            }
        },
        // 退出环信IM
        imLogout() {
            EaseChatClient.close()
            let obj = {
                currentChat: {
                    lastMessage: {}
                },
            }
            useImMessageStore().updateCurrentChat(obj)
        },
    }
})